export enum SwitchWithTextSize {
  sm = 'sm',
  md = 'md',
}

export interface SwitchProps {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  size?: SwitchWithTextSize;
  supportingText?: string;
  testId?: string;
  text?: string;
}
